<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add Law Category</h2>
            <ElementCategories category_id="3" elementName="Law"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'All Laws',
                    to: '/laws/all'
                }, {
                    text: 'Law Category',
                    href: '#'
                }
            ],
        }
    }
};
</script>
